import type { NextPage } from "next";
import { ReactElement } from "react";
import ServicePage from ".";
import { NWONPage } from "../../config/NWONPage";
import NWONServicePage from "../../src/components/04-pages/NWONServicePage/NWONServicePage";
import NWONSubServicePage from "../../src/components/04-pages/NWONSubServicePage/NWONSubServicePage";
import { NWONInitial } from "../../src/components/NWONInitial/NWONInitial";
import { useMainServiceMap } from "../../src/data/services/useMainServiceMap";
import { useSubServicesMap } from "../../src/data/sub-service/useSubServices";
import { getStaticServicePaths } from "../../src/helpers/pageCreation/servicesPageCreation/getStaticServicePaths";
import { getStaticServiceProps } from "../../src/helpers/pageCreation/servicesPageCreation/getStaticServiceProps";
import {
  GetStaticServicePaths,
  GetStaticServiceProps,
  ServicePageProps,
} from "../../src/helpers/pageCreation/servicesPageCreation/servicePageCreationInterfaces";
import { useDefaultDetailPageForSubServiceMap } from "../../src/hooks/serviceMappings/useDefaultDetailPageForSubServiceMap";

const ServiceDetailPage: NextPage<ServicePageProps> = (
  props
): ReactElement | null => {
  const { service, subService, serviceDetailPage } = props;
  const serviceMap = useMainServiceMap();
  const subServiceMap = useSubServicesMap();
  const detailPageMap = useDefaultDetailPageForSubServiceMap();
  const detailPage = subService ? detailPageMap[subService] : undefined;

  const serviceData = service ? serviceMap[service] : null;
  const subServiceData = subService ? subServiceMap[subService] : null;

  let content = <ServicePage />;
  if (serviceData && subServiceData && detailPage) {
    content = (
      <NWONSubServicePage
        service={serviceData}
        subService={subServiceData}
        serviceDetailPage={serviceDetailPage || detailPage}
      />
    );
  } else if (serviceData) {
    content = <NWONServicePage service={serviceData} />;
  }

  return (
    <NWONInitial
      pageInformationData={{
        page: NWONPage.Services,
        mainService: service,
        subService: subService,
        serviceDetailPage: serviceDetailPage,
      }}
    >
      {content}
    </NWONInitial>
  );
};

export const getStaticProps: GetStaticServiceProps = async (context) => {
  return getStaticServiceProps(context);
};

export const getStaticPaths: GetStaticServicePaths = async (context) => {
  return getStaticServicePaths(context);
};

export default ServiceDetailPage;
